import { render, staticRenderFns } from "./FichaDistribuicao.vue?vue&type=template&id=77e04d5a&"
import script from "./FichaDistribuicao.vue?vue&type=script&lang=js&"
export * from "./FichaDistribuicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports